import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { NgModule, SecurityContext } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CommonComponentsModule } from '@views/common/components/common-components.module';
import { GenericOptionsComponent } from '@views/common/components/generic-options/generic-options.component';
import {
  AVAILABILITY_PROVIDER,
  PAX_SPECIFICATION,
  RECENT_SEARCHER_SUBMITS,
  SearcherFeatureComponent,
  STATION_FILTER_QUERY,
  STATIONS_PROVIDER
} from '@vueling-ng/vy-cdk-searcher';
import { CardFeaturedModule } from '@vueling-ng/vy-ds/src/lib/components/composed/card-featured';
import { LayoutPageHeroComponent } from '@vueling-ng/vy-ds/src/lib/components/layouts/layout-page-hero';
import { AvailabilityService } from 'app/services/api-services/availability/availability.service';
import { AlertBannerModule } from 'app/shared/alerts';
import { GenericModalModule } from 'app/shared/generic-modal/generic-modal.module';
import { PassengerConfiguration } from 'app/shared/searcher/configurations/passengers.configuration';
import { FuzzySearchLevenshteinService } from 'app/shared/searcher/providers/fuzzy-search.service';
import { RecentSearchesStorageService } from 'app/shared/searcher/providers/recent-searches-storage.service';
import { SearcherStationsProvider } from 'app/shared/searcher/providers/searcher-stations.provider';
import { SECURITY_CONTEXT } from 'ngx-markdown';
import { PromotionsComponent } from './components/searcher-wrapper/components/promotions/promotions.component';
import { SearcherWrapperComponent } from './components/searcher-wrapper/searcher-wrapper.component';
import { HomeComponent } from './home.component';

@NgModule({
  declarations: [HomeComponent, SearcherWrapperComponent, PromotionsComponent, GenericOptionsComponent],
  imports: [
    CommonModule,
    RouterModule,
    CardFeaturedModule,
    SearcherFeatureComponent,
    GenericModalModule,
    TranslateModule,
    LayoutPageHeroComponent,
    CommonComponentsModule,
    AlertBannerModule,
    A11yModule
  ],
  providers: [
    {
      provide: STATIONS_PROVIDER,
      useClass: SearcherStationsProvider,
      multi: true
    },
    {
      provide: STATION_FILTER_QUERY,
      useClass: FuzzySearchLevenshteinService
    },
    {
      provide: AVAILABILITY_PROVIDER,
      useClass: AvailabilityService,
      multi: true
    },
    {
      provide: RECENT_SEARCHER_SUBMITS,
      useClass: RecentSearchesStorageService
    },
    {
      provide: SECURITY_CONTEXT,
      useValue: SecurityContext.NONE
    },
    {
      provide: PAX_SPECIFICATION,
      useClass: PassengerConfiguration,
      multi: true
    }
  ],
  exports: [HomeComponent]
})
export class HomeModule {}
